var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "evenodd",
    d: "M22.042 11.564C22.042 5.707 17.322.958 11.5.958S.958 5.707.958 11.564c0 5.294 3.855 9.682 8.895 10.478V14.63H7.176v-3.066h2.677V9.228c0-2.658 1.574-4.127 3.982-4.127 1.153 0 2.36.208 2.36.208v2.61h-1.33c-1.31 0-1.718.817-1.718 1.656v1.99h2.924l-.468 3.065h-2.456v7.412c5.04-.796 8.895-5.184 8.895-10.478"
  })));
}
export default SvgFacebook;